import { type SdkKey, getSdkInfoByKey } from '@gonfalon/sdk-info/sdkInfo';
import { Button, Text } from '@launchpad-ui/components';
import cx from 'clsx';

import styles from './ChooseSDK.module.css';

type SdkItemProps = {
  sdk: SdkKey;
  isSelected: boolean;
  compact?: boolean;
  onPress: (sdk: SdkKey) => void;
};

export function SdkItem({ sdk, isSelected, compact = false, onPress }: SdkItemProps) {
  const metadata = getSdkInfoByKey(sdk);
  if (!metadata) {
    return null;
  }

  const IconComponent = metadata.icon;
  const hasObservability = metadata.observabilitySupported === true;

  return (
    <Button
      size={compact ? 'small' : 'medium'}
      className={cx(styles.sdkItem, { [styles.sdkItemSelected]: isSelected, [styles.sdkItemCompact]: compact })}
      onPress={() => onPress(sdk)}
    >
      <div className={styles.iconContainer}>
        <IconComponent size="small" />
      </div>
      {compact ? (
        <Text className={styles.sdkName}>{metadata.name ?? sdk}</Text>
      ) : (
        <div className={styles.labelContainer}>
          <Text className={styles.sdkName}>{metadata.name ?? sdk}</Text>
          {hasObservability && <Text className={styles.observabilityText}>Observability supported</Text>}
        </div>
      )}
    </Button>
  );
}
